import React from 'react';
import Button from 'react-bootstrap/Button';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

const OrderActions = ({ orderNumber, orderStatus }) => {
    const { currentStatusId, trackingUrl } = orderStatus;
    return (
        <div>
            <Button as={Link} to={`/orders/${orderNumber}`} variant="outline-secondary" block className="btn__default">
                Szczegóły
            </Button>
            {
                {
                    delivered: (
                        <Button
                            as={Link}
                            to={`/review/${orderNumber}`}
                            variant="outline-secondary"
                            block
                            className="btn__default"
                        >
                            Oceń zamówienie
                        </Button>
                    ),
                    received: (
                        <Button
                            as={Link}
                            to={`/review/${orderNumber}`}
                            variant="outline-secondary"
                            block
                            className="btn__default"
                        >
                            Oceń zamówienie
                        </Button>
                    ),
                    sent: (
                        <a
                            href={trackingUrl}
                            className="btn__default btn btn-outline-secondary btn-block gitbtn__default"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Śledz przesyłkę
                        </a>
                    )
                }[currentStatusId]
            }
        </div>
    );
};

OrderActions.propTypes = {
    orderNumber: PropTypes.string.isRequired,
    orderStatus: PropTypes.object.isRequired,
};

export default OrderActions;
